function createMarkup(html: string) {
  return { __html: html };
}

interface HtmlTextProps {
  children: string;
  component?: 'span' | 'div';
}

function HtmlText({ component, children }: HtmlTextProps) {
  const Component = component || 'span';
  return <Component dangerouslySetInnerHTML={createMarkup(children)} />;
}

export default HtmlText;
